import * as CPL from '@teamsparta/cross-platform-logger';
import { getCookie } from 'cookies-next';

export const sendLog = (action: string, data = {}) => {
  try {
    CPL.sendCPLog(action, data);
  } catch (error) {
    console.error(error);
  }
};

export const sendBrazeLog = (eventName: string, data = {}) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    CPL.getBrazeInstance()?.logCustomEvent(eventName, data);
  } catch (error) {
    console.error('Braze log error:', error);
  }
};

export const setBrazeUserAttribute = async (
  attributeKey: string,
  attributeValue: string,
): Promise<void> => {
  if (typeof window === 'undefined') {
    return;
  }
  if (CPL.getBrazeInstance()) {
    CPL.getBrazeInstance()?.setCustomUserAttribute(
      attributeKey,
      attributeValue,
    );
  }
};

export const setAmplitudeUserProperty = (
  attributeKey: string,
  attributeValue: string,
): void => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    CPL.setAmplitudeUserProperty?.(attributeKey, attributeValue);
  } catch (error) {
    console.error('Amplitude setUserAttribute error:', error);
  }
};

export function setUtmTermToBraze(): void {
  try {
    const utmLastCookie = getCookie('utm_last');
    if (!utmLastCookie) {
      return;
    }

    const decodedUtmLast = decodeURIComponent(utmLastCookie);
    const utmData = JSON.parse(decodedUtmLast);
    const utmTerm = utmData.utm_term;

    if (utmTerm) {
      setBrazeUserAttribute('utm_term', utmTerm);
      // eslint-disable-next-line no-console
      // console.log('UTM Term set to Braze:', utmTerm); // 테스트용 로그
    }
  } catch (error) {
    console.error('Failed to set UTM Term to Braze:', error);
  }
}
